import { AbstractModel } from '@patsnap/tahiti-core';
import { CurrentMatchedPatentModel } from '../current-matched-patent-model';
import type { CurrentMatchedPatentState } from '../../types';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

function createInitialMatchedPatentState(): CurrentMatchedPatentState {
    return {
        ranking: [],
        manualAdded: [],
        extraAdded: [],
    };
}

@injectable()
export class CurrentMatchedPatentModelImpl extends AbstractModel<CurrentMatchedPatentState> implements CurrentMatchedPatentModel {
    protected _modelData: CurrentMatchedPatentState = createInitialMatchedPatentState();

    clone(data: CurrentMatchedPatentState): CurrentMatchedPatentState {
        return data;
    }

    dispose(): void {
        this.update(() => createInitialMatchedPatentState());
    }
}
